import { render, staticRenderFns } from "./SoldProductsChart.vue?vue&type=template&id=6e8216f0&scoped=true"
import script from "./SoldProductsChart.vue?vue&type=script&lang=js"
export * from "./SoldProductsChart.vue?vue&type=script&lang=js"
import style0 from "./SoldProductsChart.vue?vue&type=style&index=0&id=6e8216f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8216f0",
  null
  
)

export default component.exports